import React, { useState, useEffect, useCallback } from "react";
import Container from "react-bootstrap/Container";
import { Jumbotron } from "./migration";
import Row from "react-bootstrap/Row";
import axios from "axios";

const dummyProject = {
  name: null,
  description: null,
  svn_url: null,
  stargazers_count: null,
  languages_url: null,
  pushed_at: null,
};
const API = "https://api.github.com";

const Projects = ({ heading }) => {
  return (
    <Jumbotron id="projects">
      <h2 className="display-4 pb-5 text-center">{heading}</h2>
      <div className="container row">

        <div class="containerCard">
          <div class="cardCard">
            <div class="face face1">
              <div class="content">
                <img src="https://media1.giphy.com/media/3o6Ztrs0GnTt4GkFO0/giphy.gif?cid=ecf05e47ujcjdvjzgwzdmc10vo8oobokv72fftialhubsyr7&rid=giphy.gif" width="320" height="361" />
                <h3>Room Booking System</h3>
              </div>
            </div>
            <div class="face face2">
              <div class="content">
                <p>Designed and Implemented MVC website in .NET core framework to help patient family members book a room in hospital premises.
                .NET Core Identity used to authenticate users from Google/Facebook/Twitter/WS-Federation providers.
                RESTful Web Services used for data manipulation and Stripe API for Payment system. MS SQL Server used as a main database and
                object-relational mapping achieved using Entity Framework
                <br></br>
                 <b>Technologies used:</b> C#, CSS, JS, HTML, Razor Pages, .Net Core, .NET6, Swagger, SQL Server, EF
                </p>
              </div>
            </div>
          </div>
          <div class="cardCard">
            <div class="face face1">
              <div class="content">
                <img src="https://media4.giphy.com/media/l46Cy1rHbQ92uuLXa/giphy.gif?cid=ecf05e47896um0it2gik7qxzbwr78vg7mxybtq3tbm3wdga8&rid=giphy.gif"width="320" height="361" />
                <h3>Sensors Monitoring System</h3>
              </div>
            </div>
            <div class="face face2">
              <div class="content">
              <p>Designed and Implemented website in .NET core framework to visually represent data from various sensors in the hospital.
                RESTful Web Services used for data manipulation. MS SQL Server used as a main database and
                object-relational mapping achieved using Entity Framework
                <br></br>
                 <b>Technologies used:</b> C#, CSS, JS, HTML, Razor Pages, .Net Core, .NET5, Swagger, SQL Server, EF
                </p>              
                </div>
            </div>
          </div>
          <div class="cardCard">
            <div class="face face1">
              <div class="content">
                <img src="https://media2.giphy.com/media/pIMlKqgdZgvo4/giphy.gif?cid=ecf05e476u38stqt7brqk769iaslqiphtiu8jv3ick5307u8&rid=giphy.gif" width="320" height="361"/>
                <h3>Robotics Control System</h3>
              </div>
            </div>
            <div class="face face2">
              <div class="content">
              <p>Implemented desktop app in .NET framework to control automation unit for regulatory drug delivery testing system. ABB Robot code written in RAPID using RobotStudio IDE.
                Servo motors code written in TrioBASIC.
                MS SQL Server used as a main database. Windows Forms used for UI Design
                <br></br>
                 <b>Technologies used:</b> C#, .Net, SQL Server, RAPID, TrioBASIC
                </p>              </div>
            </div>
          </div>
          <div class="cardCard">
            <div class="face face1">
              <div class="content">
              <img src="https://media1.giphy.com/media/9JrkkDoJuU0FbdbUZU/giphy.gif?cid=ecf05e47f4cir9v8mwg302gvwvzmwqe3mj299kml50zjuou7&rid=giphy.gif" width="320" height="361"/>
               <h3>Portfolio Website</h3>
              </div>
            </div>
            <div class="face face2">
              <div class="content">
              <p>Implemented Portfolio website for myself to use it as a tool to learn front-end skills and share my experience.
                Node.js with Express.js used on a backend, where front-end mainly implemented using React framework. Nodemailer used for allowing email sending

                <br></br>
                 <b>Technologies used:</b> CSS, HTML, Node.js, Express.js, React, Bootstrap, Nodemailer
                </p>              
                </div>
            </div>
          </div>
        </div>
</div>
    </Jumbotron>
  );
};

export default Projects;
